import {BpReportModel} from "./bp-report-model";

export function getBloodPressureReportFileName(reportModel: BpReportModel): string {
  return `${reportModel.measurementCode.value}_bp_report.pdf`;
}
